import React from 'react';
import { Reveal } from '../ui/Reveal';
import { CtaButton } from '../ui/Button';
import { OFFERS_ANCHOR, PRICE } from '../../data/offer';
export function FinalCTA() {
  return <section className="bg-ink py-16 md:py-24" data-id="element-27" data-mp="3mtrz69bf4f2e">
      <div className="mx-auto max-w-2xl px-5 text-center md:px-8" data-id="element-28" data-mp="3msz2k166b5xz">
        <Reveal data-id="element-29" data-mp="3rsbliatxbsva">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/46a813cb-72f0-4089-b32d-a7acd3ce0524.jpg" alt="Los tomos de Carpintería Plegable PRO alineados sobre un banco de taller" className="mx-auto w-full rounded-2xl object-cover shadow-lift" loading="lazy" data-id="element-30" data-mp="3rrtjsyohsmfz" />
        </Reveal>

        <Reveal delay={0.05} data-id="element-31" data-mp="33x8v3yfh1hcp">
          <h2 className="mt-8 font-display text-2xl font-black uppercase leading-tight text-white sm:text-3xl md:text-[2.6rem]" data-id="element-32" data-mp="38t7gdd5i6j8w">
            Tu próximo proyecto
            <span className="block text-gold" data-id="element-33" data-mp="121q7fxjtd93i">puede empezar hoy.</span>
          </h2>

          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-cream/70 md:text-lg" data-id="element-34" data-mp="170jm3tau7659">
            Explorá nuevos proyectos de muebles plegables y sumá nuevas
            posibilidades a tu taller.
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-35" data-mp="z1grsyyrqxjp">
          <div className="mt-8 rounded-2xl border-2 border-gold/50 bg-ink-soft p-6 md:p-8" data-id="element-36" data-mp="yznjzgcf67a4">
            <p className="font-display text-[11px] font-black uppercase tracking-[0.22em] text-gold" data-id="element-37" data-mp="v0eski4uqlhq">
              Carpintería Plegable PRO™
            </p>

            <p className="mt-6 text-[10px] font-bold uppercase tracking-[0.2em] text-cream/45" data-id="element-38" data-mp="2aoc42fqz7ig">
              Desde
            </p>
            <p className="mt-1 font-display text-5xl font-black leading-none text-white md:text-6xl" data-id="element-39" data-mp="gbijqiuz14g2">
              {PRICE.from}
            </p>
            <p className="mt-3 text-[10px] font-bold uppercase tracking-[0.2em] text-cream/45" data-id="element-40" data-mp="bdh304l0ph7r">
              Pago único
            </p>

            <div className="mt-7" data-id="element-41" data-mp="1mr1bxl6ns0uk">
              <CtaButton href={OFFERS_ANCHOR} external={false} size="xl" data-id="element-42" data-mp="1mpzyxb6314a7">
                Ver las 2 ofertas
              </CtaButton>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}